import { render, staticRenderFns } from "./cprs-endorsement-application.component.vue?vue&type=template&id=2b0aabe5"
import script from "./cprs-endorsement-application.component?vue&type=script&lang=ts&external"
export * from "./cprs-endorsement-application.component?vue&type=script&lang=ts&external"
import style0 from "./cprs-endorsement-application.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports